import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {IStore} from '../../redux/interface';
import {Link, useParams} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import {useGetTranslations} from '../../utils/hooks/useGetTranslations';
import {TranslationKeys} from '../../utils/constants/routeConstants';
import {
  articleAsyncActions, getTeiArticle, getTeiArticleSections
} from '../../redux/pageAsyncActions';
import Loader from '../../components/loader';
import Section from '../../components/section';
import './styles.scss';

export const ArticleSections: React.FunctionComponent = () => {
  const {
    article,
    sections
  } = useSelector((state: IStore) => state.article);
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const dispatch = useDispatch();
  const {articleId} = useParams();

  useGetTranslations({
    translationKey: TranslationKeys.Article
  });

  useEffect(() => {
    if (articleId) {
      if (!article || article.id.toString() !== articleId) {
        dispatch(articleAsyncActions[getTeiArticle](articleId));
      }
      dispatch(articleAsyncActions[getTeiArticleSections](articleId));
    }
  }, [articleId]);

  return article && <div className="sections-page">
    <header className="sections-page__header">
      <h1><FormattedMessage
        id={'gritx.article.sections'}
        defaultMessage={'Sections'}
      /></h1>
      {article && <Link to={`/article/${article.id}`} className="sections-page__link">
        <FormattedMessage
          id={'gritx.article.backToArticle'}
          defaultMessage={'Back to article'}
        /></Link>}
    </header>
    <main className="sections-page__container">
      {!sections.length && loading.includes(getTeiArticleSections) && <Loader className="sections-page__loader"/>}
      <div className="sections-page__body">
        {sections.map((s, i) => {
          return <Section key={i} section={s}/>;
        })}
      </div>
    </main>
  </div>;
};
